@if (thumbnailList.length > 0) {
  <div class="margin-top-30 margin-bottom-20">
    <h3
      class="margin-bottom-20"
      dsContent
      [contentPath]="'claims.photoUpload.photoListHeader'"
    ></h3>
    @if (!uploadInitiated) {
      <p dsContent [contentPath]="'claims.photoUpload.photoListDescription'"></p>
    }
  </div>
}

@for (thumbnail of thumbnailList; track thumbnail) {
  <div>
    <ds-claim-photo
      [thumbnail]="thumbnail"
      [missingData]="missingData"
      (removePhotoEvent)="removePhoto($event)"
      (retryUploadEvent)="retryUpload($event)"
      (inputChangeEvent)="onPhotoInputChange()"
    >
    </ds-claim-photo>
  </div>
}

@if (!uploadInitiated || !uploadProcessed) {
  <div>
    @if (thumbnailList.length > 0) {
      <div>
        <strong
          >{{ readyToUploadThumbnailCount }} photo
          @if (readyToUploadThumbnailCount > 1) {
            <span>s</span>
          }
          ready to upload</strong
        >
        <p>{{ totalFileSize }} MB</p>
      </div>
    }
    <button
      ds-button
      [disabled]="readyToUploadThumbnailCount == 0 || !uploadReady"
      class="margin-top-20"
      (click)="uploadPhotos()"
    >
      Upload {{ readyToUploadThumbnailCount ? readyToUploadThumbnailCount : '' }} Photo
      @if (readyToUploadThumbnailCount !== 1) {
        <span>s</span>
      }
    </button>
    <a
      (click)="openGoBackModal()"
      href="javascript:void(0);"
      class="caption font-weight-semibold margin-left-10"
      >Go back</a
    >
  </div>
}
@if (uploadProcessed) {
  <div class="margin-top-20">
    <button ds-button class="pad-left-30 pad-right-30" (click)="confirmUpload()">
      Submit Photos
    </button>
  </div>
}

<ds-modal [id]="modalId" [closeOthers]="true" [maxWidth]="500">
  <div class="row">
    <div class="column twelve">
      <span class="icon-alert block"></span>
      <h2
        class="heading-main text-center"
        dsContent
        [contentPath]="'claims.photoUpload.photoUploadNavigateBackMsg1'"
      ></h2>
      @if (thumbnailList.length) {
        <p
          class="pad-top-20 text-center"
          dsContent
          [contentPath]="'claims.photoUpload.photoUploadNavigateBackMsg2'"
        ></p>
      }
      <div class="pad-top-20 text-center">
        <button
          ds-button
          class="-outline-white pad-right-50 pad-left-60 margin-right-12"
          (click)="cancelUpload()"
          dsContent
          [contentPath]="'claims.photoUpload.photoUploadNavigateBackBtnCnt1'"
        ></button>
      </div>
      <div class="pad-top-20 pad-bottom-20 text-center">
        <button
          ds-button
          class="-outline-white margin-right-12"
          (click)="stayHere()"
          dsContent
          [contentPath]="'claims.photoUpload.photoUploadNavigateBackBtnCnt2'"
        ></button>
      </div>
    </div>
  </div>
</ds-modal>
